import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Globe } from "lucide-react";
import { NAV, SITE } from "@/lib/site";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="text-white" style={{ background: "#1A3D2E" }}>
      <div className="eco-container py-14 md:py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="mb-5">
            <Logo size={64} />
          </div>
          <p className="text-[14.5px] text-white/80 leading-relaxed max-w-sm">
            Professional commercial and residential cleaning across Metro Detroit and Oakland County —
            backed by 30+ years of experience.
          </p>
          <p className="mt-5 text-[13px] uppercase tracking-[0.18em] text-white/70 font-semibold">
            Let&apos;s Be Clean Together.
          </p>
        </div>

        <div>
          <h4 className="text-[13px] uppercase tracking-[0.18em] font-semibold text-white/70 mb-4">Quick Links</h4>
          <ul className="space-y-2.5">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} data-testid={`footer-link-${n.label.toLowerCase()}`} className="text-[15px] text-white/90 hover:text-white transition-colors">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-[13px] uppercase tracking-[0.18em] font-semibold text-white/70 mb-4">Contact</h4>
          <ul className="space-y-3 text-[14.5px] text-white/90">
            <li className="flex items-start gap-2.5"><MapPin size={17} className="mt-0.5 shrink-0 text-white/70" /><span>{SITE.address}</span></li>
            <li className="flex items-center gap-2.5"><Phone size={17} className="text-white/70" /><a href={SITE.phoneHref} data-testid="footer-phone" className="hover:text-white">{SITE.phone}</a></li>
            <li className="flex items-center gap-2.5"><Mail size={17} className="text-white/70" /><a href={SITE.emailHref} data-testid="footer-email" className="hover:text-white">{SITE.email}</a></li>
            <li className="flex items-center gap-2.5"><Globe size={17} className="text-white/70" /><a href={SITE.websiteHref} className="hover:text-white">{SITE.website}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="eco-container py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-[13px] text-white/70">
          <span>© {new Date().getFullYear()} Eco Ready Solutions, LLC. All rights reserved.</span>
          <span>Royal Oak, Michigan · Serving Metro Detroit & Oakland County</span>
        </div>
      </div>
    </footer>
  );
}
